import { Core } from "@faire/design-tokens";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { EmbeddedLink } from "@faire/web--source/ui/EmbeddedLink";
import styled from "styled-components";
var StyledPill = styled(EmbeddedLink).withConfig({
    componentId: "sc-2ebe9d76-0"
})([
    "display:flex;align-items:center;padding:4px 16px 4px 4px;height:",
    ";margin-right:",
    ";border-radius:50px;background-color:",
    ";white-space:nowrap;&,&:hover,&:focus,&:focus-within{text-decoration:none;}img{display:block;border-radius:",
    ";width:",
    "px;height:",
    "px;margin-left:",
    ";}",
    "{&:hover{border-color:",
    ";}}&:focus-visible{outline:2px solid -webkit-focus-ring-color;outline-offset:-2px;"
], getSpacing("5x"), getSpacing("2x"), Core.surface.muted, function(param) {
    var $isCountryFlag = param.$isCountryFlag;
    return $isCountryFlag ? "0" : "50%";
}, function(param) {
    var $isCountryFlag = param.$isCountryFlag;
    return $isCountryFlag ? PillStyles.COUNTRY_FLAG_WIDTH : PillStyles.SQUARE_DIMENSION;
}, function(param) {
    var $isCountryFlag = param.$isCountryFlag;
    return $isCountryFlag ? PillStyles.COUNTRY_FLAG_HEIGHT : PillStyles.SQUARE_DIMENSION;
}, function(param) {
    var $isCountryFlag = param.$isCountryFlag;
    return $isCountryFlag ? "8px" : "0px";
}, responsiveMediaQueries.tabletAndAbove, Core.border.default);
export var PillStyles;
(function(PillStyles) {
    PillStyles.Pill = StyledPill;
    PillStyles.COUNTRY_FLAG_WIDTH = 18;
    PillStyles.COUNTRY_FLAG_HEIGHT = 14;
    PillStyles.SQUARE_DIMENSION = 32;
})(PillStyles || (PillStyles = {}));
